import React from 'react';
import { useSelector } from 'react-redux';
import { useHeadingsData } from './table-of-contents.hooks';
import { getLang } from 'shared/store/selectors/lang.selector';
import styles from './table-of-contents.module.scss';
import { Anchor, ConfigProvider, Skeleton } from 'antd';

const bullets = ['\u2022', '\u25E6', '\u25AA', '\u25CF', '\u25A0'];
const getBullet = level => bullets[(level - 1) % bullets.length];

const TOCTitle = ({ level, title }) => {
  return (
    <li className={styles.tocTitle} data-bullet={getBullet(level)}>
      {title}
    </li>
  );
};

const TOCSkeleton = () => (
  <div className={styles.skeleton}>
    <Skeleton active paragraph={{ rows: 4, width: ['80%', '60%', '70%', '50%'] }} title={false} />
  </div>
);

const TableOfContents = ({ content }) => {
  const lang = useSelector(getLang('KNOWLEDGE_EDITOR'));
  const { headings } = useHeadingsData({ content });

  const isLoading = content === null || headings === null;
  const isEmpty = !isLoading && headings.length === 0;

  const handleClick = (e, link) => {
    e.preventDefault();
    const targetId = link.href.replace('#', '');
    const index = parseInt(targetId.split('-')[1], 10);
    const container = document.querySelector('#content-container');
    const headingElements = container?.querySelectorAll('h1, h2, h3');
    const targetElement = headingElements?.[index];

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const renderContent = () => {
    if (isLoading) {
      return <TOCSkeleton />;
    }

    if (isEmpty) {
      return (
        <p className={styles.emptyMessage}>
          {lang.NO_HEADINGS_IN_CONTENT || 'No headings found in this document'}
        </p>
      );
    }

    return (
      <ConfigProvider
        theme={{
          token: {
            lineWidth: 0,
            lineWidthBold: 0,
          },
        }}>
        <Anchor
          affix={false}
          showInkInFixed={false}
          items={headings}
          getContainer={() => document.getElementById('full-width')}
          onClick={handleClick}
          className={styles.anchor}
        />
      </ConfigProvider>
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.toc}>{renderContent()}</div>
    </div>
  );
};

export { TableOfContents, TOCTitle };
